import { h, Component } from 'preact';
import { Router, RouterOnChangeArgs } from 'preact-router';

import Home from '../routes/home';
import NotFound from '../routes/notfound';

import Pi from './pi';

declare const require: (name: String) => any;

interface IHotModule {
    hot?: { accept: (path: string, callback: () => void) => void };
};

declare const module: IHotModule;

if (module.hot) {
	require('preact/debug');
}

export default class App extends Component<any,any> {
    currentUrl: string;

	/** Gets fired when the route changes.
	 *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
	 *	@param {string} event.url	The newly routed URL
	 */
	handleRoute = (e: RouterOnChangeArgs) => {
		this.currentUrl = e.url;
	};

	render({history}) {
		return (
			<div id="app">
				<Router onChange={this.handleRoute} history={history}>
					<Home path="/" />
                    <NotFound exact path="/404/" />
                    <NotFound default />
				</Router>
                <Pi />
                <div id="footer">
                    <span>&copy; <a href="https://slepp.ca/">Stephen Olesen</a></span>
                </div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/app.tsx